import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: 'default' | 'lg';
  showIcon?: boolean;
}
export function CTAButton({
  children,
  fullWidth = false,
  size = 'default',
  showIcon = true,
  className = '',
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0';
  const sizeStyles = size === 'lg' ? 'px-8 py-4 text-lg md:text-xl' : 'px-6 py-3 text-base';
  const widthStyles = fullWidth ? 'w-full' : '';
  const colorStyles = 'bg-[#D97757] text-white hover:bg-[#c06345]';
  return <button className={`${baseStyles} ${sizeStyles} ${widthStyles} ${colorStyles} ${className}`} {...props} data-id="element-198">
      {children}
      {showIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-199" />}
    </button>;
}